export default {
  zh: {
    emailPlaceholder: '邮箱',
    emailRegister: '邮箱注册',
    freeRegistration: '免费注册',
    registerText: '注 册',
    inviteCodeText: '邀请码',
    confirmPasswordPlaceholder: '确认密码',
    inviteCodePlaceholder: '邀请码（可选）',
    phoneRegister: '手机注册',
    phoneNumPlaceholder: '手机号码',
    setPassword: '我要设置登录密码',
    passwordPlaceholder: '密码',
    signUp: '注册',
    verificationPlaceholder: '验证码',
    sendAgain: '后重新发送',
    getVerificationCode: '获取验证码',
    networkError: '网络错误，请稍后再试',
    haveInvitationCode: '我有邀请码',
    inviteLoading: '正在验证邀请码...',
    signInWith: '第三方登录',
    newToPlex: '新用户？前往',
    sent: '已发送',
    signIn: '登录'
  },
  en: {
    emailPlaceholder: 'Email',
    emailRegister: 'Email',
    freeRegistration: 'Register',
    registerText: 'Register',
    inviteCodeText: 'Invite Code',
    confirmPasswordPlaceholder: 'Confirm password',
    inviteCodePlaceholder: 'Invite Code (optional)',
    phoneRegister: 'Phone',
    phoneNumPlaceholder: 'Phone',
    setPassword: 'Set Password',
    passwordPlaceholder: 'Password',
    signUp: 'Register',
    verificationPlaceholder: 'Your Code',
    sendAgain: 'Send again',
    getVerificationCode: 'Send SMS',
    networkError: 'Network error, please try again later',
    haveInvitationCode: 'I have an invitation code',
    inviteLoading: 'Verifying invitation codes...',
    signInWith: 'Sign in with',
    newToPlex: 'New to PlexVPN? ',
    sent: 'Sent',
    signIn: 'Sign In'
  }
}



// WEBPACK FOOTER //
// ./src/components/registerform/lang.js